import { create } from 'zustand';

import { TpSlValueState } from '../types';
import { defaultTpSlValue } from './defaultTpSlValue';

export const DEFAULT_TP_PNL_PERCENTAGE = 1;

export type TakeProfitState = {
  tpValue: TpSlValueState;
  setState: (newTpValue: Partial<TpSlValueState>) => void;
};

export const useTakeProfitStore = create<TakeProfitState>()((set) => ({
  tpValue: defaultTpSlValue,
  setState: (newTpValue: Partial<TpSlValueState>) =>
    set((_state) => ({
      ..._state,
      tpValue: {
        ..._state.tpValue,
        ...newTpValue,
      },
    })),
}));
